<ng-container *ngIf="snapProduct !== 'custom'">
    <div [ngClass]="visualization === 'Line Chart' ? 'popup-trend' : 'popup'">
        <div class="part1">
            <p [innerHTML]="popUpParameter"></p>
            <div class="DataLabel-Container-Main" *ngIf="visualization == 'Line Chart' ">
                <div class="DataLabel-Container-text">Data Label</div>
                <div class="DataLabel-Container">
                    <div [style]="DataLabelOn?'background-Color:#000000;color:white':'background-Color:#fff;color:black'"
                        class="DataLabelButtons" (click)="DataLabelOnClick()">On</div>
                    <div [style]="!DataLabelOn?'background-Color:#000000;color:white':'background-Color:#fff;color:black'"
                        class="DataLabelButtons" (click)="DataLabelOffClick()">Off</div>
                </div>
            </div>
            <div class="Top10-All-Container" *ngIf="Top10Container==true">
                <div class="Top10-Block" [ngClass]="{'ToggleActive':Top10Toggle}" (click)="Top10selected()">
                    Top 10
                </div>
                <div class="All-Block" [ngClass]="{'ToggleActive':!Top10Toggle}" (click)="Allselected()">
                    All
                </div>
            </div>
            <div style="display:flex;align-items:center" class="Icons-Container">
                <img src="../../../../assets/images/snap_output_icons/info.svg" alt="" style="display:none">
                <img src="../../../../assets/images/snap_output_icons/Icon_collapse.svg" alt=""
                    (click)="collapseExandPopup()">
            </div>
        </div>
        <hr>
        <div [ngClass]="visualization === 'Line Chart' ? 'part2-trend' : 'part2'">
            <app-snapshot-chartsparent style="width: 98%; height: 100%;" *ngIf="item.metric.length>0" [popUp]="true"
                [chart]="visualization" [id]="id" [data]="data" [height]="'100%'" [Top10Toggle]="Top10Toggle"
                [DataLabelOn]="DataLabelOn"></app-snapshot-chartsparent>
            <div class="chart-section-text" *ngIf="item.metric.length<1">
                <div *ngIf="item.metric.length<1 && item.noData==undefined">Widget is not configured.</div>
                <div *ngIf="item.metric.length<1 && item.noData==true">No data available for the selection.</div>
            </div>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="snapProduct == 'custom' && visualization != 'Line Chart'">
    <!-- <div [ngClass]="visualization === 'Line Chart' ? 'popup-trend' : 'popup'"> -->
    <div [ngClass]="visualization === 'Line Chart' ? 'popup-trend' : (showSnapshotARK ? 'popup-snapshot' : 'popup')">

        <!-- Extra Selections Controls -->
        <div class="extraSelections" *ngIf="false && showSnapshotARK">
            <div class="sigIndexArea">
                <div class="sigArea">
                    <div style="display: flex; position: relative; width: 100%; height: 100%; align-items: center; justify-content: center;"
                        class="initialSelected">
                        <p class="btn-text" style="width: 100%; text-align: center;">Sig</p>
                    </div>
                </div>
                <div class="indexArea">
                    <div style="display: flex; position: relative; width: 100%; height: 100%; align-items: center;">
                        <p class="btn-text" style="width: 100%; text-align: center;">Index</p>
                    </div>
                </div>
            </div>
            <div class="dropdown-container">
                <div class="significanceDropdown">
                    <div>Significance</div>
                    <div class="significance-dropdown-outer-body">
                        <div class="dd">
                            <p class="dropdown-btn-text">None</p>
                            <div alt="" class="icon Down-Arrow"></div>
                        </div>
                        <div class="b hide-dropdown">
                            <div class="dropdown-values">
                                <div style="display: flex; width: 100%; position: relative;">
                                    <div class="itemData" title="None">
                                        <span class="dropdown-text-values">None</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="confidenceLeveldropdown DNN disabled">
                    <div>Confidence Level </div>
                    <div class="confidence-level-outer-body">
                        <div class="dd">
                            <p class="dropdown-btn-text">90%</p>
                            <div alt="" class="icon Down-Arrow"></div>
                        </div>
                        <div class="Confidence-level-dropdown hide-dropdown">
                            <div class="dropdown-values">
                                <div style="display: flex; width: 100%; position: relative;">
                                    <div class="itemData selected-item" title="90%">
                                        <span class="dropdown-text-values">90%</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="baseDropdown">
                    <div>Base</div>
                    <div class="base-dropdown-outer-body">
                        <div class="dd custom-base-dd">
                            <p class="dropdown-btn-text">Answer Base</p>
                            <div alt="" class="icon Down-Arrow"></div>
                        </div>
                        <div class="Base-dropdown hide-dropdown">
                            <div class="dropdown-values">
                                <div style="display: flex; width: 100%; position: relative;">
                                    <div class="itemData" title="Total Base">
                                        <span class="dropdown-text-values">Total Base</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="weightdropdownContainer">
                    <div>Weight </div>
                    <div class="weighted-dropdown-outer-body">
                        <div class="dd">
                            <p class="dropdown-btn-text">Primary Weight</p>
                            <div alt="" class="icon Down-Arrow"></div>
                        </div>
                        <div class="weight-dropdown hide-dropdown">
                            <div class="dropdown-values">
                                <div style="display: flex; width: 100%; position: relative;">
                                    <div class="itemData selected-item" title="Primary Weight">
                                        <span class="dropdown-text-values">Primary Weight</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div [ngClass]="visualization === 'Line Chart' ? 'part2-trend' : 'part2'">
            <!-- *ngIf="item.metric.length>0" -->
            <app-snapshot-chartsparent [snapProduct]="'custom'" style="width: 98%; height: 100%;"
                [customData]="customData" [isOutput]="true" [popUp]="true" [height]="'100%'"
                [metricSelected]="metricSelected" [brandSelected]="brandSelected" [Top10Toggle]="Top10Toggle"
                [DataLabelOn]="DataLabelOn"></app-snapshot-chartsparent>
            <!-- <app-snapshot-chartsparent style="width: 98%; height: 100%;"  [popUp]="true" [chart]="visualization" [id]="id" [data]="data" [height]="'100%'" [Top10Toggle]="Top10Toggle" [DataLabelOn]="DataLabelOn"></app-snapshot-chartsparent> -->
            <!-- <div class="chart-section-text" *ngIf="item.metric.length<1">
                <div *ngIf="item.metric.length<1 && item.noData==undefined">Widget is not configured.</div>
                <div *ngIf="item.metric.length<1 && item.noData==true">No data available for the selection.</div>
            </div> -->
            <div *ngIf="charttype === 'Bubble Chart'" class="note-bottom">
                <!-- Content for Bubble Chart -->
                Note: Bubble Radius:{{zAxisMetric}}
            </div>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="snapProduct == 'custom' && multiFunnelPopup">
    <div [ngClass]="visualization === 'Line Chart' ? 'popup-trend' : 'multifunnelpopup'">
        <div class="part1">
            <p [innerHTML]="popUpParameter"></p>
            <div class="DataLabel-Container-Main" *ngIf="visualization == 'Line Chart' ">
                <div class="DataLabel-Container-text">Data Label</div>
                <div class="DataLabel-Container">
                    <div [style]="DataLabelOn?'background-Color:#000000;color:white':'background-Color:#fff;color:black'"
                        class="DataLabelButtons" (click)="DataLabelOnClick()">On</div>
                    <div [style]="!DataLabelOn?'background-Color:#000000;color:white':'background-Color:#fff;color:black'"
                        class="DataLabelButtons" (click)="DataLabelOffClick()">Off</div>
                </div>
            </div>
            <div class="Top10-All-Container" *ngIf="Top10Container==true">
                <div class="Top10-Block" [ngClass]="{'ToggleActive':Top10Toggle}" (click)="Top10selected()">
                    Top 10
                </div>
                <div class="All-Block" [ngClass]="{'ToggleActive':!Top10Toggle}" (click)="Allselected()">
                    All
                </div>
            </div>
            <div style="display:flex;align-items:center" class="Icons-Container">
                <!-- <img src="../../../../assets/images/snap_output_icons/info.svg" alt="" style="display:none">
                <img src="../../../../assets/images/snap_output_icons/Icon_collapse.svg" alt=""
                    (click)="collapseExandPopup()"> -->
                <div class="close-icon" (click)="collapseExandPopup()"></div>
            </div>
        </div>
        <hr>
        <div [ngClass]="visualization === 'Line Chart' ? 'part2-trend' : 'multifunnelpart2'">
            <!-- <app-snapshot-chartsparent [snapProduct]="'custom'"  style="width: 98%; height: 100%;"
            [customData]="customData" [isOutput]="true" [popUp]="true"  [height]="'22em'"></app-snapshot-chartsparent> -->
            <div class="grid-container">
                <div class="grid-item" [ngStyle]="{'width': (i % 3 === 0) ? 'auto' : 'auto'}"
                    *ngFor="let cell of gridData;let i=index">
                    <h3>{{cell.header}}</h3>
                    <hr>
                    <!-- <app-snapshot-chartsparent [snapProduct]="'custom'"  style="width: 98%; height: 100%;"
                  [customData]="customData" [isOutput]="false" [popUp]="true"  [height]="'10em'"></app-snapshot-chartsparent> -->
                    <app-funnelchart1-custom *ngIf="customData.widgetchart_name=='FUNNEL CHART'"
                        [selectedBrand]="cell.header" [isOutput]="true" [multiFunnelPopup]="multiFunnelPopup"
                        [popUp]="false" [customData]="cell.data" [id]="i+90" [height]="'13em'"
                        [gridTempleteColumns]="''" [showXaxisLabels]="i%3==0?true:false"></app-funnelchart1-custom>
                </div>
            </div>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="snapProduct == 'custom' && visualization == 'Line Chart'">
    <div [ngClass]="visualization === 'Line Chart' ? 'popup-trend' : 'popup'">
        <div class="part1">
            <p [innerHTML]="popUpParameter"></p>
            <div style="display:flex;align-items:center" class="Icons-Container">
                <!-- <img src="../../../../assets/images/snap_output_icons/info.svg" alt="" style="display:none">
                <img src="../../../../assets/images/snap_output_icons/Icon_collapse.svg" alt=""
                    (click)="collapseExandPopup()"> -->
                <div class="close-icon" (click)="collapseExandPopup()"></div>
            </div>
        </div>
        <hr>
        <div *ngIf="isTrendView" [ngClass]="visualization === 'Line Chart' ? 'part2-trend' : 'part2'">
            <!-- *ngIf="item.metric.length>0" -->
            <div class="dropdowns-conatiner-trend">
                <!-- for only trendline 2 for customsnapshot -->
                <div class="trend-or-samplesize">
                    <div class="toggle-container" (click)="toggleTrendSample('trendview')"
                        [ngClass]="{'Selected':isTrendView}">Trend View</div>
                    <div class="toggle-container" (click)="toggleTrendSample('samplesize')"
                        [ngClass]="{'Selected':isSampleSize}">Sample Size</div>
                </div>
                <div class="view-container" *ngIf="visualization == 'Line Chart' && trendLineView && trendLineView==2 "
                    DocumentClick (DocumentClicked)="closeViewDropdown()">
                    <div class="view-Container-text">View</div>
                    <div class="viewdropdown">
                        <button class="drop-toggle  flat" (click)="toogleViewDropdown()">
                            <span class="selectText"
                                [title]="viewselected">{{(viewselected==""?'Select':viewselected)}}</span>
                            <span class="fa fa-angle-down arrowicon"><img class="downarrow"
                                    src="../../../../assets/ImagesSnapshot/Public/key-downDown.svg"></span>
                        </button>
                        <div class="view-drop-down" *ngIf="isviewDropdownOpen"
                            [ngStyle]="{'padding':viewList.length>0?'4px':'0px','border':viewList.length>0?'1px solid #BABABA':'none'}">
                            <div class="item-container" *ngFor="let item of viewList"
                                [ngClass]="{'selected':item.selected}">
                                <input type="radio" class="checkbox-radio" (click)="viewSelected(item)"
                                    id="{{item.option}}" [checked]="item.selected">
                                <label for="{{item.option}}" class="checkbox-label"
                                    [title]="item.option">{{item.option}}</label><br>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="viewdropdown" *ngIf="visualization == 'Line Chart' && trendLineView && trendLineView==2 "
                    DocumentClick (DocumentClicked)="closeBrandMetricDropdown()">
                    <button class="drop-toggle  flat" (click)="toogleBrandMetricDropdown()">
                        <span class="selectText"
                            [title]="viewselected=='All Brands for Selected Metric'?(metricSelected==''?'Select':metricSelected):(brandSelected==''?'Select':brandSelected)">{{viewselected=='All
                            Brands for Selected
                            Metric'?(metricSelected==''?'Select':metricSelected):(brandSelected==''?'Select':brandSelected)}}</span>
                        <span class="fa fa-angle-down arrowicon"><img class="downarrow"
                                src="../../../../assets/ImagesSnapshot/Public/key-downDown.svg"></span>
                    </button>
                    <div class="view-drop-down" *ngIf="toogleBrandMetricDropdownOpen"
                        [ngStyle]="{'padding':BMList.length>0?'4px':'0px','border':BMList.length>0?'1px solid #BABABA':'none' ,'width':viewList.length>0?'12vw':'0px'}">
                        <div class="item-container" *ngFor="let item of BMList;let i=index"
                            [ngClass]="{'selected':item.selected}">
                            <input type="radio" class="checkbox-radio" (click)="brandMetricSelected(item,i)"
                                id="{{item.option}}" [checked]="item.selected">
                            <label for="{{item.option}}" class="checkbox-label"
                                [title]="item.option">{{item.option}}</label><br>
                        </div>
                    </div>
                </div>
            </div>
            <app-snapshot-chartsparent [snapProduct]="'custom'" style="width: 98%; height: 100%;"
                [customData]="customData" [isOutput]="true" [popUp]="true" [height]="'100%'"
                [metricSelected]="metricSelected" [brandSelected]="brandSelected" [Top10Toggle]="Top10Toggle"
                [DataLabelOn]="DataLabelOn"></app-snapshot-chartsparent>
            <!-- <app-snapshot-chartsparent style="width: 98%; height: 100%;"  [popUp]="true" [chart]="visualization" [id]="id" [data]="data" [height]="'100%'" [Top10Toggle]="Top10Toggle" [DataLabelOn]="DataLabelOn"></app-snapshot-chartsparent> -->
            <div class="chart-section-text" *ngIf="item.metric.length<1">
                <div *ngIf="item.metric.length<1 && item.noData==undefined">Widget is not configured.</div>
                <div *ngIf="item.metric.length<1 && item.noData==true">No data available for the selection.</div>
            </div>
        </div>
        <div *ngIf="isSampleSize" [ngClass]="visualization === 'Line Chart' ? 'part2-trend' : 'part2'">
            <!-- *ngIf="item.metric.length>0" -->
            <div class="dropdowns-conatiner-trend">
                <div class="trend-or-samplesize">
                    <div class="toggle-container" (click)="toggleTrendSample('trendview')"
                        [ngClass]="{'Selected':isTrendView}">Trend View</div>
                    <div class="toggle-container" (click)="toggleTrendSample('samplesize')"
                        [ngClass]="{'Selected':isSampleSize}">Sample Size</div>
                </div>
                <div class="insightcontainer">
                    <div class="insight-download-area">
                        <!-- <div class="insight-icon"></div> -->
                        <div class="download-icon"></div>
                    </div>
                </div>
            </div>
            <app-table-ouput [data]="OutputdataObject" [isTranspose]="false" [isTotalBase]="false" [isAnswerBase]="true"
                [isSampleSize]="true" [selectedDataFormat]="'0'" [isWeightedLabel]="true"
                [DefaultConfidenceLevel]="'90%'" [isWeightedNumerator]="false" [isUnWeightedNumerator]="false"
                [insufficientBase]="'30'" [LowBase]="'100'" [DefaultSampleSize]="'None'" [isSampleSizeBlock]="true"
                [isWeightedSampleBlock]="false" [isPairWise]="false" [threshold]="'false'" [selectedIndex]="'0'"
                [isIndex]="false" [selectedWeight]="'Primary Weight'"></app-table-ouput>
        </div>
    </div>
</ng-container>